import type { ImpactItem } from "@/lib/types";

export default function Impact({ items = [] }: { items?: ImpactItem[] }) {
  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-sm font-semibold text-primary-600">
            Votre don en action
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Concrètement, à quoi sert votre générosité ?
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Chaque don est transformé en aide directe et mesurable sur le
            terrain, en Afrique et en Asie.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item) => (
            <article
              key={item.title}
              className="bg-background-50 rounded-lg border border-background-200 overflow-hidden flex flex-col"
            >
              <div className="h-52 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} — Humanity59`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}